import React, { useEffect } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Meta from "../Meta/Meta";
// import { Helmet } from "react-helmet";

function TermsAndCondition() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
      <Meta
        title="Terms and Conditions | MaxiPitch"
        description="Review the terms and conditions for using MaxiPitch AI sales automation platform, including user responsibilities, service rules, and usage policies."
        url="https://maxipitch.com/terms-and-Conditions"
      />
      {/* <Helmet>
        <title>Review the Selfsync's Terms of Service</title>
        <meta
          name="description"
          content="Review SelfsyncAI’s Terms of Service. Understand the conditions, payment terms, cancellation policies, and legal framework for using our platform."
        />
        <link rel="canonical" href="https://maxipitch.com /terms-of-service" />
      </Helmet> */}
      <Header />
      <section id="content" className="container mx-auto px-8 max-md:px-4">
        <div className="text-center mb-8 mt-5 leading-tight">
          <h1 className="">Terms of Service</h1>
          <div className="mt-3 text-lg  max-md:text-base text-gray-500">
            Last Modified 12 December, 2025
          </div>
        </div>
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Left Section */}
          <div className="flex-1">
            <div className="term-of-services space-y-6">
              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800">
                DEFINITIONS
              </h6>
              <p className="text-gray-700">
                In these conditions, “Maxipitch ” , upon whose document these
                conditions are endorsed. The term "Customer" designates the
                individual, entity, or organization to whom such document is
                addressed.
              </p>

              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800">
                FORMATION OF CONTRACT
              </h6>
              <p className="text-gray-700">
                2.1 Terms and Conditions All goods, services, or facilities are
                offered, and all contracts are entered into subject to the
                following conditions of business by Maxipitch.
              </p>
              <p className="text-gray-700">
                2.2 Incorporation into Contract These conditions shall be
                incorporated into any contract between Maxipitch and the
                Customer to the exclusion of any terms or conditions stipulated
                or referred to by the Customer. Any dealings with Maxipitch
                following the receipt by the Customer of notice of these
                conditions shall automatically be deemed acceptance thereof,
                notwithstanding the absence of formal acknowledgment.
              </p>
              <p className="text-gray-700">
                2.3 Quotations and Estimates Unless otherwise expressly stated
                in writing, all quotations and estimates supplied by Maxipitch
                are invitations to make an offer. The Customer’s order is an
                offer and shall become binding upon acceptance by Maxipitch .
              </p>

              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800">
                TERMS OF PAYMENT
              </h6>
              <p className="text-gray-700">
                4.1 Payment Terms Subject to condition 5.2 and unless otherwise
                agreed by Maxipitch in writing, all invoices rendered by
                Maxipitch are payable within 30 days of the dates thereof.
              </p>
              <p className="text-gray-700">
                4.2 Payment Options Maxipitch expressly reserves the right, at
                its sole option, to require payment by installments during the
                performance of the contract and/or payment of all amounts owing
                to Maxipitch immediately prior to delivery.
              </p>
              <p className="text-gray-700">
                4.3 No Set Off or Counterclaim The Customer shall pay all
                amounts owing to Maxipitch in full and shall not exercise any
                rights of set off or counterclaim against invoices submitted.
              </p>

              <h6 className="text-2xl  max-md:text-xl  font-bold text-gray-800">
                CANCELLATION
              </h6>
              <p className="text-gray-700">
                {" "}
                5.1 Cancellation and Variation Any contract between Maxipitch
                and the Customer may only be canceled or varied with the written
                consent of Maxipitch and upon the terms of these conditions. The
                giving of ’s consent shall not in any way prejudice Maxipitch ’s
                right to recover from the Customer full compensation for any
                loss or expense arising from such cancellation or variation.
              </p>
              <p className="text-gray-700">
                5.2 Notice of Cancellation Charges Without prejudice to any
                other rights or remedies available to Maxipitch , if notice of
                cancellation of a booking is received by Maxipitch less than 24
                hours prior to the date for performance of the contract,
                Maxipitch shall be entitled to charge such booking in full under
                Maxipitch ’s rate card current at the date of such cancellation.
                If such a notice of cancellation is received less than five
                working days but more than 24 hours prior to the date for
                performance of the contract, Maxipitch shall be entitled,
                without prejudice to any other rights or remedies available to
                it, to charge such booking at one half of the full rate under
                Maxipitch ’s rate card current at the date of such cancellation.
              </p>

              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800">
                TITLE AND IP OWNERSHIP
              </h6>
              <p className="text-gray-700">
                6.1 Transfer of Title to the goods the subject of the contract
                or any relevant part thereof shall only pass to the Customer
                upon the Customer paying to Maxipitch all sums due and payable
                by it to Maxipitch under the relevant contract and all other
                prior contracts between Maxipitch and the Customer.
              </p>
              <p className="text-gray-700">
                6.2 Copyright Assignment Upon full payment by the Customer,
                Maxipitch , with full title guarantee, will assign to the
                Customer (by way of assignment of present and future copyright)
                the entire copyright and all other rights of whatsoever kind or
                nature throughout the world in and to all the products of
                Maxipitch ’s services.
              </p>
              <p className="text-gray-700">
                6.3 Ownership Retention Without prejudice to the assignment
                referred to in condition 10.2, for the avoidance of doubt,
                Maxipitch shall retain ownership of the following: computer
                software, technical processes, trade secrets, and technical
                devices and know-how developed by or used by Maxipitch in order
                to create the goods or services, excluding any third-party
                software.
              </p>

              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800">
                LEGAL
              </h6>
              <p className="text-gray-700">
                7.1 Governing Law and Jurisdiction The contract shall be
                governed and interpreted exclusively according to the laws of
                the Indian Judiciary (without regard to its conflict of laws
                principles) and shall be subject to the exclusive jurisdiction
                of the High Court and Supreme Courts of that state located in
                Mumbai, INDIA. The Customer hereby waives any right it may have
                to a trial by jury with respect to any claim arising out of or
                related to any contract with Maxipitch .
              </p>
              <p className="text-gray-700">
                7.2 Attorney Fees and Damages If Maxipitch files an action
                against the Customer claiming a breach of these Conditions and
                Maxipitch prevails, then Maxipitch shall be entitled to recover
                reasonable attorney fees and any damages or other relief that
                Maxipitch may be awarded.
              </p>

              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800 mt-10">
                GDPR COMPLIANCE
              </h6>
              <p className="text-gray-700">
                8.1 Data Controller: Maxipitch acts as a Data Controller under
                the General Data Protection Regulation (EU) 2016/679 ("GDPR").
                We are responsible for determining the purposes and means of
                processing personal data.
              </p>
              <p className="text-gray-700">
                8.2 User Rights: Users located in the European Union have the
                following rights under the GDPR: the right to access their data,
                rectify inaccuracies, request erasure (“right to be forgotten”),
                restrict or object to processing, and data portability. To
                exercise these rights, users may contact us at{" "}
                <a
                  href="mailto:support@maxipitch.com "
                  className="text-blue-600 underline"
                >
                  support@maxipitch.com
                </a>
                .
              </p>
              <p className="text-gray-700">
                8.3 Data Collection & Purpose: Maxipitch collects and processes
                personal data only for specified, legitimate purposes such as
                account creation, service provision, analytics, and user
                support.
              </p>
              <p className="text-gray-700">
                8.4 Legal Basis: We process personal data based on user consent,
                the necessity of performing a contract, compliance with legal
                obligations, and legitimate interests where applicable.
              </p>
              <p className="text-gray-700">
                8.5 Data Retention: Personal data is retained only for as long
                as necessary to fulfill the purposes for which it was collected
                or to comply with legal obligations.
              </p>
              <p className="text-gray-700">
                8.6 Data Transfers: Where personal data is transferred outside
                the European Economic Area (EEA), we ensure appropriate
                safeguards are in place, such as Standard Contractual Clauses
                (SCCs).
              </p>

              <h6 className="text-2xl max-md:text-xl  font-bold text-gray-800 mt-10">
                EU AI ACT COMPLIANCE
              </h6>
              <p className="text-gray-700">
                9.1 Transparency and Disclosure: Maxipitch clearly discloses
                when users are interacting with AI-powered systems. All
                AI-generated content and outputs are appropriately labeled.
              </p>
              <p className="text-gray-700">
                9.2 Risk Management: Maxipitch regularly assesses and mitigates
                risks related to its AI systems in accordance with the risk
                classifications of the EU AI Act.
              </p>
              <p className="text-gray-700">
                9.3 Human Oversight: AI outputs are subject to human oversight
                and review where applicable. Users have the option to report
                undesired AI behavior or errors.
              </p>
              <p className="text-gray-700">
                9.4 Data Governance: Training data used for AI models complies
                with EU standards, ensuring high-quality, representative, and
                non-discriminatory data inputs.
              </p>
              <p className="text-gray-700">
                9.5 User Rights: Users are informed of their right to opt out of
                automated decision-making processes unless such processing is
                necessary for a contract or authorized by law.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="py-4"></div>
      <Footer />
    </div>
  );
}

export default TermsAndCondition;
